import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PasswordCheck } from 'assets/icons/PasswordCheck.svg';
import { ReactComponent as PasswordErrorCross } from 'assets/icons/PasswordErrorCross.svg';

import { STYLE } from 'constants/style';
import { getPasswordRules, IPasswordRule } from 'utils/passwordRules';

import { useStyles } from './styles';

interface IPasswordStrengthCheckerProps {
  password: string;
  email?: string;
  mobilePhoneNumber?: string;
  className?: string;
}

const PasswordStrengthChecker: React.FC<IPasswordStrengthCheckerProps> = ({
  password,
  email,
  mobilePhoneNumber,
  className,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const passwordRules = useMemo(() => getPasswordRules(t), [t]);

  return (
    <div className={`${classes.container} ${className || ''}`}>
      <p className={classes.title}>{t('createPassword.passwordMatcher.rules.title')}</p>
      <div className={classes.rulesList}>
        {passwordRules.map((rule, index) => (
          <PasswordRuleLine
            key={index}
            rule={rule}
            password={password}
            email={email}
            mobilePhoneNumber={mobilePhoneNumber}
          />
        ))}
      </div>
    </div>
  );
};

const PasswordRuleLine = ({
  rule,
  password,
  email,
  mobilePhoneNumber,
}: {
  rule: IPasswordRule;
  password: string;
  email?: string;
  mobilePhoneNumber?: string;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isValid = rule.test(password, { email, mobilePhoneNumber });
  return (
    <div className={classes.ruleItem}>
      {isValid ? <PasswordCheck /> : <PasswordErrorCross />}
      <p className={`${classes.ruleText} ${isValid ? classes.ruleSuccess : classes.ruleError}`}>{t(rule.key)}</p>
    </div>
  );
};

export default PasswordStrengthChecker;
